import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TopAppBarTitle as RmwcTopAppBarTitle} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcTopAppBarTitle = styled(RmwcTopAppBarTitle)``

const TopAppBarTitle = ({children, ...otherProps}) => <StyledRmwcTopAppBarTitle {...otherProps}>{children}</StyledRmwcTopAppBarTitle>

TopAppBarTitle.propTypes = {
  children: PropTypes.any
}

export {TopAppBarTitle}
